export const graphQLUri =
  import.meta.env.VITE_GRAPHQL_URI ??
  'https://api-staging.coherentpath.com/spa-graphql/';
